import { useRouteMatch } from 'react-router';

import { UnexpectedError } from 'utils/errors';

export const useRouteMatchStrict = <ParamsType>() => {
  const match = useRouteMatch<ParamsType>();

  if (match) {
    return match;
  }

  throw new UnexpectedError();
};
